import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export function initGalleryLightbox(): void {
  const galleries = document.querySelectorAll<HTMLElement>('.wp-block-gallery');

  galleries.forEach(gallery => {
    const containers = gallery.querySelectorAll<HTMLElement>(
      '.wp-lightbox-container'
    );
    if (!containers.length) return;

    type Slide = { href: string; type: 'image' };

    // Build the slide list from each image's largest available src
    const elements: Slide[] = Array.from(containers).map(container => {
      const img = container.querySelector('img');
      // Prefer the full-size src from srcset if available
      let href = img?.src || '';
      const srcset = img?.getAttribute('srcset');
      if (srcset) {
        const largest = srcset
          .split(',')
          .map(s => {
            const [url, width] = s.trim().split(/\s+/);
            return { url, width: parseInt(width ?? '0') };
          })
          .sort((a, b) => b.width - a.width)[0];
        if (largest?.url) href = largest.url;
      }
      return { href, type: 'image' as const };
    });

    const lightbox = GLightbox({
      elements: elements as unknown as [],
      loop: true,
      touchNavigation: true,
    });

    containers.forEach((container, index) => {
      const trigger = container.querySelector<HTMLElement>('.lightbox-trigger');
      const img = container.querySelector<HTMLElement>('img');

      // Intercept WP's Interactivity API handler via capture phase
      const openAt = (e: Event) => {
        e.stopPropagation();
        e.preventDefault();
        lightbox.openAt(index);
      };

      if (trigger) trigger.addEventListener('click', openAt, true);
      if (img) img.addEventListener('click', openAt, true);
    });
  });
}
